import { CommonService } from 'api-new/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

type DeleteInput = {
  id: number;
  userId?: number;
};
export const useDeleteCommonRepairOrderQuotePartMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof CommonService.deleteCommonRepairOrderQuotePart>>,
      QueryError,
      DeleteInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    (input: DeleteInput) => {
      return CommonService.deleteCommonRepairOrderQuotePart(input.id, input.userId);
    },
    {
      ...options,
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
